import { useMediaQuery } from "@mui/material";
import React from "react";
import { ImageGrid } from "@/components/ImageGrid";
import { PageModule } from "@/components/PageModule";
import { theme } from "@/theme";
import { ImageAttributes } from "@/store";

export interface ImageGridSliderProps {
  images: ImageAttributes[];
  startAtIndex?: number;
}
export const ImageGridSlider = ({
  images,
  startAtIndex,
}: ImageGridSliderProps) => {
  return (
    <PageModule className="max-w-full px-0">
      <ImageGrid images={images} startAtIndex={startAtIndex} />
    </PageModule>
  );
};
